import type { AdminFormStatus as Status } from "../hooks/useAdminForm";

interface AdminFormStatusProps {
  status: Status;
  error: string | null;
  /**
   * Shown on success, if given. Omit it for a form whose `onSaved` callback
   * already navigates/transitions away (e.g. `CreateSeasonForm`,
   * `ClearSeasonResults`) — there's nothing left on screen to show it next to.
   */
  savedLabel?: string;
}

/** The status message tail every admin form's `.admin-panel__actions` row ends with. */
export function AdminFormStatus({ status, error, savedLabel }: AdminFormStatusProps) {
  if (status === "success" && savedLabel) {
    return <span className="admin-panel__status">{savedLabel}</span>;
  }
  if (status === "error") {
    return <span className="admin-panel__status admin-panel__status--error">{error}</span>;
  }
  return null;
}
